import { Body, breakpoints, colors } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'

type TabProps = {
    onClick?: () => void
    text: string
    active?: boolean
}

const TabContainer = styled.div<{ active?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &:hover {
        cursor: pointer;
    }
`

const TabButton = styled.div`
    z-index: 1;
    display: flex;
`

const Text = styled(Body.SmBold)<{ $active }>`
    padding: 0 24px;
    color: ${({ $active }) =>
        $active ? `var(--text-contrast, ${colors.white})` : `var(--text-primary, ${colors.black})`};
    ${breakpoints.xsmall} {
        padding: 0 8px;
        text-align: center;
        line-height: 16px;
    }
`

export const Tab = React.forwardRef<HTMLDivElement, TabProps>(
    ({ text, onClick, active = false }, ref) => {
        return (
            <TabContainer ref={ref} onClick={() => onClick?.()} active={active}>
                <TabButton>
                    <Text $active={active} size={16}>
                        {text}
                    </Text>
                </TabButton>
            </TabContainer>
        )
    }
)
